import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ordersStatus'
})
export class OrdersStatusPipe implements PipeTransform {

  status: string = '';
  transform(value: number): unknown {
    switch (value) {
      case 0: {
        this.status = 'Nuevo';
        break;
      }
      case 1: {
        this.status = 'Aceptado';
        break;
      }
      case 2: {
        this.status = 'Rechazado';
        break;
      }
      case 3: {
        this.status = 'Asignado a cadete';
        break;
      }
      case 4: {
        this.status = 'Cancelado';
        break;
      }
       case 5: {
        this.status = 'Cadete confirmado';
        break;
      }
      case 6: {
        this.status = 'En viaje/Para retirar';
        break;
      }
      case 7: {
        this.status = 'Finalizado';
        break;
      }
      case 8: {
        this.status = 'Devuelto';
        break;
      }
    }
    return this.status;
  }

}
